import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import _ from 'lodash';

export default function reportReducer(state = initialstate.reportInfo, action) {
	switch (action.type) {
		case types.GET_REPORT_DATA:
			let _state = {...state};
			if (action.response) {
				return {..._state, [action.reportType]: action.response};
			}else{
				return {}
			}
			break;
		default:
			return state;
	}
}
